import { Poppins } from "next/font/google";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import "@/styles/globals.css";
import { getPopup } from "../service/apiFetch";
import MetaTags from "../components/Head/MetaTags";
import Popup from "../components/utils/Popup";
import DefaultLayout from "@/layouts/default";

const Snackbar = dynamic(() => import("@/components/utils/Snackbar"), {
  ssr: false,
});

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
  display: "swap",
  variable: "--font-poppins",
});

function App({ Component, pageProps }) {
  const router = useRouter();
  const [popupData, setPopupData] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(true);

  useEffect(() => {
    if (process.env.NODE_ENV === "development") return undefined;

    let active = true;
    const getPopupApi = async () => {
      try {
        const data = await getPopup({ limit: "all" });
        if (active && data.length) {
          setPopupData(data);
        }
      } catch (error) {
        // Ignore popup fetch failures.
      }
    };

    getPopupApi();
    return () => {
      active = false;
    };
  }, []);

  const shouldShowPopup =
    popupData.length > 0 &&
    router.pathname !== "/bestanthropologycoaching" &&
    router.pathname !== "/bestanthropologytestseries" &&
    router.pathname !== "/thank-you" &&
    (popupData[0].displayOn === "all" ||
      (popupData[0].displayOn === "home" && router.pathname === "/"));

  const { title, data, websiteData, metaTags, ...restProps } = pageProps;

  return (
    <div className={poppins.variable}>
      {(metaTags ||
        data?.pageData?.metaTags ||
        websiteData?.website?.metaTags ||
        websiteData?.website?.description ||
        websiteData?.website?.title) && (
        <MetaTags
          title={title || websiteData?.website?.title}
          keywords={metaTags?.keywords || websiteData?.website?.metaTags?.keywords}
          description={
            metaTags?.ogDescription ||
            websiteData?.website?.metaTags?.ogDescription ||
            websiteData?.website?.description
          }
          image={metaTags?.ogImage || websiteData?.website?.metaTags?.ogImage}
          url={websiteData?.website?.host || undefined}
        />
      )}

      <DefaultLayout websiteData={websiteData}>
        <Component {...{ websiteData, data, ...restProps }} />

        {shouldShowPopup && (
          <Popup
            data={popupData}
            isOpen={isPopupOpen}
            onClose={() => setPopupOpen(false)}
          />
        )}
      </DefaultLayout>

      <Snackbar />
    </div>
  );
}

export default App;
